<template>
    <el-dialog title="Multi update"
               width="1100px"
               top="50px"
               :visible.sync="showForm"
                :close-on-click-modal="false">

                <table class="table multi-update" v-if="data && stats && data.multicarrier && data.singlecarrier">
                    <tbody>
                    <tr>
                        <th style="width: 160px;">Action</th>
                        <th></th>
                        <th colspan="2">Current Status</th>
                    </tr>
                    <dialog-campaign-multiupdate-row name="mc_enabled" :stats="stats" :updates="updates" :watch="data.multicarrier.enabled">
                        <div style="display: flex; justify-content: space-between">
                            <el-checkbox v-model="data.multicarrier.enabled"><h3>Multi-Carrier</h3></el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_budget" :stats="stats" :updates="updates" :watch="data.multicarrier.budget">
                        <div class="cd-section" style="display: flex; align-items: center; margin-left: 23px;">
                            Monthly budget
                            <input type="number" class="form-control" style="width: 200px; margin: 0 15px;"
                                   v-model="data.multicarrier.budget"></input>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_app_goal_manual" :stats="stats" :updates="updates" :watch="data.multicarrier.app_goal_enabled" :watch2="data.multicarrier.app_goal">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center">
                                <el-checkbox v-model="data.multicarrier.app_goal_enabled">Monthly lead goal</el-checkbox>
                                <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                       v-model="data.multicarrier.app_goal"></input>
                                drivers per month
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_app_goal_rollover" :stats="stats" :updates="updates" :watch="data.multicarrier.rollover_enabled" :watch2="data.multicarrier.rollover">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.multicarrier.rollover_enabled">Plus rollover</el-checkbox>
                                <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                       v-model="data.multicarrier.rollover"></input>
                                leads from previous month
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_daily_app_goal" :stats="stats" :updates="updates" :watch="data.multicarrier.daily_pacing.enabled" :watch2="data.multicarrier.daily_pacing.app_goal" :watch3="data.multicarrier.daily_pacing.app_goal_enabled">
                        <div class="cd-section">
                            <el-checkbox v-model="data.multicarrier.daily_pacing.enabled">Daily pacing</el-checkbox>
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.multicarrier.daily_pacing.app_goal_enabled">Day cap to</el-checkbox>
                                <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                       v-model="data.multicarrier.daily_pacing.app_goal"></input>
                                drivers per day
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_daily_autopacing" :stats="stats" :updates="updates" :watch="data.multicarrier.daily_pacing.autopacing">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.multicarrier.daily_pacing.autopacing">Automatic daily pacing
                                </el-checkbox>
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_promoted" :stats="stats" :updates="updates" :watch="data.multicarrier.promoted">
                        <div class="cd-section">
                            <el-checkbox v-model="data.multicarrier.promoted">MC Promoted</el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="mc_owner_operator" :stats="stats" :updates="updates" :watch="data.multicarrier.owner_operator">
                        <div class="cd-section">
                            <el-checkbox v-model="data.multicarrier.owner_operator">Owner Operator MC</el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>


                    <dialog-campaign-multiupdate-row name="direct_enabled" :stats="stats" :updates="updates" :watch="data.singlecarrier.enabled">
                        <div class="cd-section">
                            <el-checkbox v-model="data.singlecarrier.enabled"><h3>Direct</h3></el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="direct_budget" :stats="stats" :updates="updates" :watch="data.singlecarrier.budget">
                        <div class="cd-section" style="display: flex; align-items: center; margin-left: 23px;">
                            Monthly budget
                            <input type="number" class="form-control" style="width: 200px; margin: 0 15px;"
                                   v-model="data.singlecarrier.budget"></input>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="direct_app_goal_manual" :stats="stats" :updates="updates" :watch="data.singlecarrier.app_goal">
                        <div style="display: flex; align-items: center">
                            <el-checkbox v-model="data.singlecarrier.app_goal_enabled">Monthly lead goal</el-checkbox>
                            <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                   v-model="data.singlecarrier.app_goal"></input>
                            drivers per month
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="direct_app_goal_rollover" :stats="stats" :updates="updates" :watch="data.singlecarrier.rollover_enabled" :watch2="data.singlecarrier.rollover">
                        <div style="display: flex; align-items: center; margin-left: 30px;">
                            <el-checkbox v-model="data.singlecarrier.rollover_enabled">Plus rollover</el-checkbox>
                            <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                   v-model="data.singlecarrier.rollover"></input>
                            leads from previous month
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="direct_weekly_app_goal" :stats="stats" :updates="updates" :watch="data.singlecarrier.weekly_pacing.enabled" :watch2="data.singlecarrier.weekly_pacing.app_goal_enabled" :watch3="data.singlecarrier.weekly_pacing.app_goal">
                        <div class="cd-section">
                            <el-checkbox v-model="data.singlecarrier.weekly_pacing.enabled">Weekly pacing</el-checkbox>
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.singlecarrier.weekly_pacing.app_goal_enabled">Week cap to</el-checkbox>
                                <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                                       v-model="data.singlecarrier.weekly_pacing.app_goal"></input>
                                drivers per week
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="direct_weekly_autopacing" :stats="stats" :updates="updates" :watch="data.singlecarrier.weekly_pacing.autopacing">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.singlecarrier.weekly_pacing.autopacing">Automatic weekly pacing
                                </el-checkbox>
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="products_job_board" :stats="stats" :updates="updates" :watch="data.singlecarrier.products.job_board.enabled">
                        <div class="cd-section">
                            <el-checkbox v-model="data.singlecarrier.products.job_board.enabled">Job Board</el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="products_job_board_promoted" :stats="stats" :updates="updates" :watch="data.singlecarrier.products.job_board.promoted">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.singlecarrier.products.job_board.promoted">Promoted</el-checkbox>
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="products_calls" :stats="stats" :updates="updates" :watch="data.singlecarrier.products.direct_calls.enabled">
                        <div class="cd-section">
                            <el-checkbox v-model="data.singlecarrier.products.direct_calls.enabled">Twilio tracked calls
                            </el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="products_deja" :stats="stats" :updates="updates" :watch="data.singlecarrier.products.deja.enabled">
                        <div class="cd-section">
                            <el-checkbox v-model="data.singlecarrier.products.deja.enabled">DEJA</el-checkbox>
                        </div>
                    </dialog-campaign-multiupdate-row>

                    <dialog-campaign-multiupdate-row name="products_deja_live_transfer" :stats="stats" :updates="updates" :watch="data.singlecarrier.products.deja.live_transfer">
                        <div class="cd-section">
                            <div style="display: flex; align-items: center; margin-left: 30px;">
                                <el-checkbox v-model="data.singlecarrier.products.deja.live_transfer">JA Live Transfers</el-checkbox>
                            </div>
                        </div>
                    </dialog-campaign-multiupdate-row>
                    </tbody>
                </table>

            </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
import DialogCampaignMultiupdateRow from "./dialog-campaign-multiupdate-row";

export default {
        components: {DialogCampaignMultiupdateRow},
        props: [
            'show',
            'selected_campaigns',
            'period'
        ],
        data() {
            return {
                data: {
                    current: null,
                    next: null
                },
                stats: null,
                updates: {
                    current: [],
                    next: [],
                }
            };
        },
        watch: {
            show() {
                if (this.show) {
                    this.refresh();
                }
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            refresh() {
                axios.get(url(`admin/budget-order/multi/default`))
                    .then((response) => {
                        this.data = _.cloneDeep(response.data.order);
                    });

                axios.post(url(`admin/budget-order/multi/stats`), {
                        'campaign_ids': this.selected_campaigns,
                        'period': this.period
                    }).then((response) => {
                        this.stats = response.data.stats;
                        this.updates = _.mapValues(_.mapKeys(this.stats, (key) => key.id), (v) => 'original');
                    });
            },
            save() {
                return axios.post(url(`admin/budget-order/multi/store`), {
                    campaign_ids: this.selected_campaigns,
                    period: this.period,
                    budget_order: this.data,
                    updates: this.updates
                }).then(() => {
                    this.$message.success('Campaigns updated');
                    this.showForm = false;
                    this.$emit('updated');
                });
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style scoped>
    .multi-update .cd-section {
        margin-top: 0px;
    }
    .multi-update h3 {
        margin-bottom: 0px;
    }
</style>
